import React from "react";

import "./style.scss";

const Loader = ({value}) => <div className="loader"></div>;

export default Loader;
